import React from 'react';
import { Box, Skeleton, Stack, Paper } from '@mui/material';

function SkeletonLoader() {
  return (
    <Box sx={{ p: 3 }}>
      {/* Page Title with Info Icon */}
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 3 }}>
        <Skeleton variant="text" width={150} height={40} />
        <Skeleton variant="circular" width={20} height={20} />
      </Stack>

      {/* Navigation and Search Bar */}
      <Paper elevation={0} sx={{ p: 2, mb: 2, backgroundColor: '#fff' }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          {/* Back Button */}
          <Skeleton variant="circular" width={32} height={32} />

          {/* Search Field */}
          <Skeleton variant="rectangular" width={200} height={40} sx={{ borderRadius: 1 }} />
        </Stack>
      </Paper>

      {/* Table Header */}
      <Paper elevation={0} sx={{ backgroundColor: '#f5f5f5' }}>
        <Stack direction="row" sx={{ p: 2, borderBottom: '1px solid #e0e0e0' }}>
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width={60} height={24} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width={100} height={24} />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width={100} height={24} />
          </Box>
          <Box sx={{ width: 100 }}>
            <Skeleton variant="text" width={60} height={24} />
          </Box>
        </Stack>

        {/* Table Rows */}
        {[1, 2, 3, 4, 5].map(row => (
          <Stack key={row} direction="row" sx={{ p: 2, borderBottom: '1px solid #e0e0e0' }}>
            <Box sx={{ flex: 1 }}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Skeleton variant="rectangular" width={24} height={24} />
                <Skeleton variant="text" width="60%" height={24} />
              </Stack>
            </Box>
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="70%" height={24} />
            </Box>
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="60%" height={24} />
            </Box>
            <Box sx={{ width: 100 }}>
              <Skeleton variant="circular" width={32} height={32} />
            </Box>
          </Stack>
        ))}
      </Paper>
    </Box>
  );
}

export default SkeletonLoader;
